import React from 'react'
import { useThrottle, useToggle } from 'rooks'
import { ExpandIcon } from 'components/content/ExpandIcon'
import { BASE_INTERACTION_DURATION, THROTTLE_SAFETY } from '../../../components/patterns/icons/animation/constants'
import { Box, FlexBox } from 'ui/primitives'
import { Typography } from 'ui/typography'
import { collapsedBox, hiddenBox } from './Accordion.css'

interface Props {
	title: string
	initiallyExpanded?: boolean
}

export const Accordion: React.FC<React.PropsWithChildren<Props>> = ({ title, children, initiallyExpanded }) => {
	const [expanded, setExpanded] = useToggle(initiallyExpanded)
	const [throttledClickHandler] = useThrottle(setExpanded, BASE_INTERACTION_DURATION + THROTTLE_SAFETY)

	return (
		<FlexBox direction="column" padding={{ xs: 'md', md: 'lg' }} borderRadius="sm" boxShadow="sm">
			<FlexBox
				justifyContent="space-between"
				gap="xl"
				width="fullWidth"
				cursor="pointer"
				onClick={throttledClickHandler}
			>
				<Typography fontSize={{ xs: 'lg', md: 'xl' }} fontWeight="bold">
					{title}
				</Typography>
				<ExpandIcon value={expanded} />
			</FlexBox>
			<Box className={expanded ? collapsedBox : hiddenBox} aria-hidden={!expanded}>
				{children}
			</Box>
		</FlexBox>
	)
}
